import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormHelperService {
  constructor() {}

  disableControls(controls: AbstractControl[]): void {
    controls.forEach(control => {
      control.disable({ emitEvent: false });
    });
  }

  enableControls(controls: AbstractControl[]): void {
    controls.forEach(control => {
      control.enable({ emitEvent: false });
    });
  }

  setControlsValue<T>(value: T, controls: AbstractControl[]): void {
    controls.forEach(control => {
      control.setValue(value, { emitEvent: false });
    });
  }
}
